<template>
  <BreadCrumb PageTitle="Détails du produit" />
  <ViewProduit />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
  import ViewProduit from "../../../components/Ecommerce/Produit/ViewProduit.vue";

  export default defineComponent({
    name: "ViewProduitPage",
    components: {
      BreadCrumb,
      ViewProduit,
    },
  });
</script>